import React, { useEffect, useState, useContext } from 'react';
import './AnnouncementsFeed.css';
import { StateContext } from '../../../StateProvider';
import { fetchAnnouncements } from '../../../Utilities/api';

const AnnouncementsFeed = () => {
  const { user } = useContext(StateContext);
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const loadAnnouncements = async () => {
        const data = await fetchAnnouncements();
        const userRole = user && user.role ? user.role : null;
        const filtered = [];

        for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (!item.target_roles || (userRole && item.target_roles.indexOf(userRole) !== -1)) {
            filtered.push(item);
        }
        }

        filtered.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
        });

        setAnnouncements(filtered);
    };

    loadAnnouncements();
  }, [user]);

  if (!announcements || announcements.length === 0) {
    return null;
  }

  return (
    <div className="staff-section-wrapper">
      <div className="staff-section-title">
        <span>📣</span> News & Notifications
      </div>
      <ul className="notification-list">
        {announcements.map(function (item, index) {
          return (
            <li key={index}>
              {item.title} – {item.message}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default AnnouncementsFeed;
